// change with your own variables
type EnvType = {
  PUBLIC_URL: string;
  VITE_APP_TYPE: string;
  VITE_API_URL: string;
  VITE_API_KEY: string;
  VITE_COMPANY_NAME: string;
  VITE_COMPANY_REGISTERED: string;
  VITE_OG_TITLE: string;
  VITE_OG_DESCRIPTION: string;
  VITE_OG_IMAGE: string;
  VITE_OG_SITE_NAME: string;
  VITE_KEYWORDS: string;
  VITE_FAVICON: string;
  VITE_LINK_FACEBOOK: string;
  VITE_LINK_INSTAGRAM: string;
  VITE_LINK_YOUTUBE: string;
  VITE_OG_URL: string;
  VITE_EXTERNAL_LOGIN_PREFIX: string;
  VITE_GOOGLE_TAG_ID: string;
  VITE_FB_APP_ID: string;
  NODE_ENV: string;
  VITE_APP_VERSION: string;
};

export const env: EnvType = { ...import.meta.env, ...window.env } as EnvType;

export const isDevEnvironment = (): boolean => {
  return env.NODE_ENV === 'development';
};
